import { render } from "./StatusForm.vue?vue&type=template&id=01580fd1&scoped=true"
import script from "./StatusForm.vue?vue&type=script&lang=js"
export * from "./StatusForm.vue?vue&type=script&lang=js"

import "./StatusForm.vue?vue&type=style&index=0&id=01580fd1&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01580fd1"]])

export default __exports__